module.exports = __webpack_public_path__ + "img/img_kuangxuan_hover.89183fa8.png";